module.exports = __webpack_public_path__ + "static/slack-noise-2-26ed37ebf5fe7035a01b5981d29e86a2.png";